 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import PROLOGUE from '@/components/Prologue'
 import CHAPTER1UNUSUALSUSPECTS from '@/components/Chapter-1-Unusual-Suspects'
 import CHAPTER2THETESTIMONYOFEAMSOALIE from '@/components/Chapter-2-The-Testimony-of-Eamsoalie'
 import CHAPTER3THETESTIMONYOFKULE from '@/components/Chapter-3-The-Testimony-of-Kule'
 import INTERLUDE from '@/components/Interlude'
 import CHAPTER4HOWEAMSOALIEBECAMEQUEEN from '@/components/Chapter-4-How-Eamsoalie-Became-Queen'
 import CHAPTER5AVISIONOFQUARN from '@/components/Chapter-5-A-Vision-of-Quarn'
 import CHAPTER6HOWTHEEYEWASFOUND from '@/components/Chapter-6-How-the-Eye-was-Found'
 import CHAPTER7THEDEATHOFCUIALFIL from '@/components/Chapter-7-The-Death-of-Cuialfil'
 import CHAPTER8THETESTIMONYOFELIC from '@/components/Chapter-8-The-Testimony-of-Elic'
 import CHAPTER9THETESTIMONYOFILIANA from '@/components/Chapter-9-The-Testimony-of-Iliana'
 import INTERLUDE2 from '@/components/Interlude-2'
 import CHAPTER10HOWKULFWASRESCUED from '@/components/Chapter-10-How-Kulf-was-Rescued'
 import CHAPTER11THETESTIMONYOFMONAL from '@/components/Chapter-11-The-Testimony-of-Monal'
 import CHAPTER12OUTOFTHEWILDERNESS from '@/components/Chapter-12-Out-of-the-Wilderness'
 import INTERLUDE3 from '@/components/Interlude-3'
 import CHAPTER13THETESTIMONYOFJUANIAN from '@/components/Chapter-13-The-Testimony-of-Juanian'
 import INTERLUDE4 from '@/components/Interlude-4'
 import CHAPTER14WHOISTAPEWORM from '@/components/Chapter-14-Who-is-Tapeworm'
 import INTERLUDE5 from '@/components/Interlude-5'
 import CHAPTER15HOWTHEYCAMETOSYBOARSH from '@/components/Chapter-15-How-they-Came-to-Syboarsh'
 import INTERLUDE6 from '@/components/Interlude-6'
 import CHAPTER16THETESTIMONYOFMOSTRALIOBSHAL from '@/components/Chapter-16-The-Testimony-of-Mostraliob-Shal'
 import CHAPTER17ENSEMBLE from '@/components/Chapter-17-Ensemble'
 import CHAPTER18CURTAINCALL from '@/components/Chapter-18-Curtain-Call'
 import ABOUTTHEAUTHOR from '@/components/About-the-Author'
 import COPYRIGHT from '@/components/Copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Chapter-1-Unusual-Suspects",
 			"name" : "Chapter-1-Unusual-Suspects",
 			"component" : CHAPTER1UNUSUALSUSPECTS
 		},
 		{
 			"path" : "/Chapter-2-The-Testimony-of-Eamsoalie",
 			"name" : "Chapter-2-The-Testimony-of-Eamsoalie",
 			"component" : CHAPTER2THETESTIMONYOFEAMSOALIE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js